// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Orbit homepage. Atmosphere now lives in AmbientBackdrop and is driven by
   [data-mood] on <html>, so this file only styles the dial and stage. */

.orbit-page {
  --orbit-ink: var(--text-primary);
  --orbit-muted: var(--text-secondary);
  --orbit-accent: var(--accent);
  --orbit-soft: var(--mood-halo);

  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: var(--layout-page-max);
  margin: 0 auto;
  min-height: 0;
  height: 100%;
  color: var(--orbit-ink);
  overflow: hidden;
  outline: none;
}

.orbit-page--popover-open,
.orbit-page--popover-open .orbit-shell {
  overflow: visible;
}

.orbit-page--popover-open .orbit-dial {
  overflow: visible;
}

.orbit-shell {
  position: relative;
  z-index: 1;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  outline: none;
  /* Horizontal swipes rotate the dial; no page scroll on the homepage. */
  touch-action: none;
}

/* Stage fills everything above the dial and centres the active moment. */
.orbit-stage {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: var(--space-4) 0 var(--space-3);
  overflow: hidden;
}

.orbit-stage-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  width: 100%;
  max-height: 100%;
  text-align: center;
  animation: orbit-stage-in 0.4s ease both;
}

.orbit-page--reduced .orbit-stage-panel {
  animation: none;
}

@keyframes orbit-stage-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.orbit-stage-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  order: 2;
}

.orbit-stage-object {
  position: relative;
  display: grid;
  place-items: center;
  order: 1;
  width: 100%;
  min-height: 0;
  max-height: min(280px, 38vh);
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.orbit-mode-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  background: var(--accent-soft);
  border: 1px solid var(--accent-ring);
  color: var(--accent);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.orbit-stage-title {
  margin: 0;
  font-size: clamp(32px, 4.6vw, 48px);
  line-height: 1.05;
  letter-spacing: -0.035em;
  color: var(--text-primary);
}

.orbit-stage-body {
  margin: 0;
  max-width: 36ch;
  color: var(--orbit-muted);
  line-height: 1.5;
}

.orbit-stage-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  margin-top: var(--space-3);
}

.orbit-stage-halo {
  position: absolute;
  width: min(280px, 88%);
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    var(--mood-halo) 0%,
    color-mix(in srgb, var(--mood-halo) 40%, transparent) 46%,
    transparent 72%
  );
  transition: background 0.6s ease;
}

.orbit-stage-image {
  position: relative;
  z-index: 1;
  width: auto;
  max-width: min(188px, 58%);
  max-height: min(200px, 32vh);
  height: auto;
  object-fit: contain;
  animation: orbit-float 5.8s ease-in-out infinite;
  transition: transform 0.25s ease;
  pointer-events: none;
  filter: drop-shadow(0 18px 32px rgba(0, 0, 0, 0.45));
}

.orbit-stage-image--bed {
  max-width: min(214px, 66%);
}

.orbit-stage-image--cabinet {
  max-width: min(200px, 62%);
}

.orbit-stage-add {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  width: min(140px, 48%);
  max-height: min(140px, 28vh);
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--surface-1);
  border: 1.5px dashed var(--accent-ring);
  color: var(--accent);
  box-shadow: var(--shadow-md);
  animation: orbit-float 5.8s ease-in-out infinite;
}

.orbit-stage-object:hover .orbit-stage-image,
.orbit-stage-object:hover .orbit-stage-add {
  transform: scale(1.04);
}

.orbit-page--reduced .orbit-stage-image,
.orbit-page--reduced .orbit-stage-add {
  animation: none;
}

@keyframes orbit-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-7px); }
}

.orbit-dial {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) 0 calc(var(--space-4) + env(safe-area-inset-bottom, 0px));
  touch-action: none;
  cursor: grab;
  user-select: none;
  z-index: 2;
  background: transparent;
  overflow: visible;
}

.orbit-page.is-dragging .orbit-dial {
  cursor: grabbing;
}

.orbit-dial--popover-open {
  z-index: 5;
}

.orbit-add-popover {
  --popover-shift-x: 0px;
  position: absolute;
  left: 50%;
  bottom: calc(100% + 14px);
  transform: translateX(calc(-50% + var(--popover-shift-x)));
  width: min(420px, calc(100vw - 48px));
  padding: 14px;
  border-radius: 20px;
  background: color-mix(in srgb, var(--surface-2) 92%, transparent);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-lg);
  backdrop-filter: blur(18px);
  z-index: 8;
  animation: orbit-popover-in 0.22s ease both;
  pointer-events: auto;
}

.orbit-page--reduced .orbit-add-popover {
  animation: none;
}

@keyframes orbit-popover-in {
  from {
    opacity: 0;
    transform: translateX(calc(-50% + var(--popover-shift-x))) translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateX(calc(-50% + var(--popover-shift-x))) translateY(0);
  }
}

.orbit-add-popover::after {
  content: '';
  position: absolute;
  left: calc(50% - var(--popover-shift-x));
  bottom: -7px;
  width: 14px;
  height: 14px;
  transform: translateX(-50%) rotate(45deg);
  background: var(--surface-2);
  border-right: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
}

.orbit-add-popover-title {
  margin: 0 0 10px;
  color: var(--accent);
  letter-spacing: 0.02em;
}

.orbit-add-popover-empty {
  margin: 0;
  color: var(--orbit-muted);
  padding: 4px 2px 2px;
}

.orbit-add-popover-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.orbit-add-widget {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border-subtle);
  border-radius: 16px;
  background: var(--surface-3);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.orbit-add-widget:hover {
  border-color: var(--accent-ring);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.orbit-add-widget-art {
  display: grid;
  place-items: center;
  width: 100%;
  height: 72px;
  border-radius: 12px;
  /* closest-side keeps the glow inside the tile, otherwise the circle is still
     opaque where it meets the short edges and reads as a hard band. */
  background: radial-gradient(
    ellipse closest-side at 50% 45%,
    var(--mood-halo) 0%,
    transparent 100%
  );
}

.orbit-add-widget-art img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  pointer-events: none;
}

.orbit-add-widget-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.orbit-add-widget-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.25;
}

.orbit-add-widget-desc {
  font-size: 11px;
  color: var(--orbit-muted);
  line-height: 1.35;
}

.orbit-dial-glow {
  position: absolute;
  top: 28px;
  left: 50%;
  width: min(420px, 78%);
  height: 88px;
  transform: translateX(-50%);
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    var(--mood-halo) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.orbit-dial-items {
  position: relative;
  width: min(680px, 100%);
  height: 138px;
  margin: 0 auto;
  overflow: visible;
}

.orbit-dial-slot {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 84px;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease;
  will-change: transform, opacity;
}

.orbit-dial-slot--popover-open {
  z-index: 60;
}

.orbit-page.is-dragging .orbit-dial-slot,
.orbit-page--reduced .orbit-dial-slot {
  transition: none;
}

.orbit-dial-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--orbit-ink);
  font: inherit;
}

.orbit-dial-remove {
  position: absolute;
  top: -4px;
  right: 4px;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--border-subtle);
  background: var(--surface-3);
  color: var(--text-secondary);
  cursor: pointer;
  opacity: 0;
  transform: scale(0.85);
  transition: opacity 0.18s ease, transform 0.18s ease, color 0.18s ease,
    border-color 0.18s ease;
}

.orbit-dial-slot:hover .orbit-dial-remove,
.orbit-dial-remove:focus-visible {
  opacity: 1;
  transform: scale(1);
}

.orbit-dial-remove:hover {
  color: var(--color-warning-red);
  border-color: var(--color-warning-red);
}

/* Touch devices have no hover, so keep the control on the selected routine */
@media (hover: none) {
  .orbit-dial-slot:has(.orbit-dial-item.is-active) .orbit-dial-remove {
    opacity: 1;
    transform: scale(1);
  }
}

.orbit-dial-orb {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--surface-2);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;
}

.orbit-dial-orb img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  pointer-events: none;
}

.orbit-dial-orb--add {
  border-style: dashed;
  border-color: var(--accent-ring);
  background: transparent;
  color: var(--accent);
}

.orbit-dial-item.is-active .orbit-dial-orb {
  width: 78px;
  height: 78px;
  border-color: var(--accent-ring);
  background: var(--surface-3);
  box-shadow:
    0 0 0 4px var(--accent-softer),
    var(--shadow-md);
}

.orbit-dial-item.is-active .orbit-dial-orb img {
  width: 46px;
  height: 46px;
}

.orbit-dial-item.is-active .orbit-dial-orb--add {
  border-style: solid;
  border-color: var(--accent);
  color: var(--accent);
}

.orbit-dial-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--text-tertiary);
  white-space: nowrap;
}

.orbit-dial-item.is-active .orbit-dial-label {
  color: var(--accent);
}

@media (max-width: 860px) {
  .orbit-stage-panel {
    gap: var(--space-3);
  }

  .orbit-stage-object {
    max-height: min(220px, 34vh);
  }

  .orbit-dial-items {
    height: 128px;
  }
}

@media (max-width: 768px) {
  :root {
    --orbit-dial-reserve: calc(148px + env(safe-area-inset-bottom, 0px));
  }

  .orbit-stage {
    padding: var(--space-3) 0 var(--space-2);
  }

  .orbit-stage-object {
    max-height: min(180px, 30vh);
  }

  .orbit-stage-image {
    max-width: min(148px, 46%);
    max-height: min(148px, 26vh);
  }

  .orbit-stage-image--bed {
    max-width: min(168px, 52%);
  }

  .orbit-stage-image--cabinet {
    max-width: min(156px, 48%);
  }

  .orbit-stage-add {
    width: min(112px, 40%);
    max-height: min(112px, 22vh);
  }

  .orbit-dial {
    padding-bottom: calc(var(--space-3) + env(safe-area-inset-bottom, 0px));
  }
}

@media (max-width: 640px) {
  .orbit-stage-title {
    font-size: clamp(26px, 7.5vw, 34px);
  }

  .orbit-stage-body {
    font-size: 14px;
  }

  .orbit-add-popover {
    width: min(340px, calc(100vw - 32px));
    padding: 12px;
  }

  .orbit-add-popover-grid {
    grid-template-columns: 1fr;
  }

  .orbit-add-widget {
    flex-direction: row;
    align-items: center;
  }

  .orbit-add-widget-art {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
  }

  .orbit-add-widget-art img {
    width: 40px;
    height: 40px;
  }

  .orbit-dial-slot {
    width: 72px;
  }

  .orbit-dial-orb {
    width: 58px;
    height: 58px;
  }

  .orbit-dial-item.is-active .orbit-dial-orb {
    width: 68px;
    height: 68px;
  }

  .orbit-dial-orb img {
    width: 34px;
    height: 34px;
  }

  .orbit-dial-item.is-active .orbit-dial-orb img {
    width: 40px;
    height: 40px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .orbit-stage-panel,
  .orbit-dial-item,
  .orbit-stage-image,
  .orbit-stage-add {
    transition: none !important;
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA;wEACwE;;AAExE;EACE,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;;EAE9B,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,MAAM;EACN,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB;;;;;GAKC;EACD,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,gCAAgC;EAChC,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,uCAAuC;EACvC,oBAAoB;EACpB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iFAAiF;EACjF,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,0DAA0D;EAC1D,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,iEAAiE;EACjE,sCAAsC;EACtC,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,0EAA0E;EAC5E;EACA;IACE,UAAU;IACV,wEAAwE;EAC1E;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,4BAA4B;EAC5B,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;sEACoE;EACpE;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6EAA6E;EAC7E,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB;2BACyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,4BAA4B;EAC5B,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,4BAA4B;EAC5B;;oBAEkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oEAAoE;EACtE;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,uEAAuE;EACzE;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;;;;IAIE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF","sourcesContent":["/* Orbit homepage. Atmosphere now lives in AmbientBackdrop and is driven by\n   [data-mood] on <html>, so this file only styles the dial and stage. */\n\n.orbit-page {\n  --orbit-ink: var(--text-primary);\n  --orbit-muted: var(--text-secondary);\n  --orbit-accent: var(--accent);\n  --orbit-soft: var(--mood-halo);\n\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n  max-width: var(--layout-page-max);\n  margin: 0 auto;\n  min-height: 0;\n  height: 100%;\n  color: var(--orbit-ink);\n  overflow: hidden;\n  outline: none;\n}\n\n.orbit-page--popover-open,\n.orbit-page--popover-open .orbit-shell {\n  overflow: visible;\n}\n\n.orbit-page--popover-open .orbit-dial {\n  overflow: visible;\n}\n\n.orbit-shell {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  outline: none;\n  /* Horizontal swipes rotate the dial; no page scroll on the homepage. */\n  touch-action: none;\n}\n\n/* Stage fills everything above the dial and centres the active moment. */\n.orbit-stage {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: center;\n  min-height: 0;\n  padding: var(--space-4) 0 var(--space-3);\n  overflow: hidden;\n}\n\n.orbit-stage-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-4);\n  width: 100%;\n  max-height: 100%;\n  text-align: center;\n  animation: orbit-stage-in 0.4s ease both;\n}\n\n.orbit-page--reduced .orbit-stage-panel {\n  animation: none;\n}\n\n@keyframes orbit-stage-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.orbit-stage-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2);\n  min-width: 0;\n  order: 2;\n}\n\n.orbit-stage-object {\n  position: relative;\n  display: grid;\n  place-items: center;\n  order: 1;\n  width: 100%;\n  min-height: 0;\n  max-height: min(280px, 38vh);\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.orbit-mode-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  border: 1px solid var(--accent-ring);\n  color: var(--accent);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.orbit-stage-title {\n  margin: 0;\n  font-size: clamp(32px, 4.6vw, 48px);\n  line-height: 1.05;\n  letter-spacing: -0.035em;\n  color: var(--text-primary);\n}\n\n.orbit-stage-body {\n  margin: 0;\n  max-width: 36ch;\n  color: var(--orbit-muted);\n  line-height: 1.5;\n}\n\n.orbit-stage-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  margin-top: var(--space-3);\n}\n\n.orbit-stage-halo {\n  position: absolute;\n  width: min(280px, 88%);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    var(--mood-halo) 0%,\n    color-mix(in srgb, var(--mood-halo) 40%, transparent) 46%,\n    transparent 72%\n  );\n  transition: background 0.6s ease;\n}\n\n.orbit-stage-image {\n  position: relative;\n  z-index: 1;\n  width: auto;\n  max-width: min(188px, 58%);\n  max-height: min(200px, 32vh);\n  height: auto;\n  object-fit: contain;\n  animation: orbit-float 5.8s ease-in-out infinite;\n  transition: transform 0.25s ease;\n  pointer-events: none;\n  filter: drop-shadow(0 18px 32px rgba(0, 0, 0, 0.45));\n}\n\n.orbit-stage-image--bed {\n  max-width: min(214px, 66%);\n}\n\n.orbit-stage-image--cabinet {\n  max-width: min(200px, 62%);\n}\n\n.orbit-stage-add {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: min(140px, 48%);\n  max-height: min(140px, 28vh);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: var(--surface-1);\n  border: 1.5px dashed var(--accent-ring);\n  color: var(--accent);\n  box-shadow: var(--shadow-md);\n  animation: orbit-float 5.8s ease-in-out infinite;\n}\n\n.orbit-stage-object:hover .orbit-stage-image,\n.orbit-stage-object:hover .orbit-stage-add {\n  transform: scale(1.04);\n}\n\n.orbit-page--reduced .orbit-stage-image,\n.orbit-page--reduced .orbit-stage-add {\n  animation: none;\n}\n\n@keyframes orbit-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-7px); }\n}\n\n.orbit-dial {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) 0 calc(var(--space-4) + env(safe-area-inset-bottom, 0px));\n  touch-action: none;\n  cursor: grab;\n  user-select: none;\n  z-index: 2;\n  background: transparent;\n  overflow: visible;\n}\n\n.orbit-page.is-dragging .orbit-dial {\n  cursor: grabbing;\n}\n\n.orbit-dial--popover-open {\n  z-index: 5;\n}\n\n.orbit-add-popover {\n  --popover-shift-x: 0px;\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 14px);\n  transform: translateX(calc(-50% + var(--popover-shift-x)));\n  width: min(420px, calc(100vw - 48px));\n  padding: 14px;\n  border-radius: 20px;\n  background: color-mix(in srgb, var(--surface-2) 92%, transparent);\n  border: 1px solid var(--border-subtle);\n  box-shadow: var(--shadow-lg);\n  backdrop-filter: blur(18px);\n  z-index: 8;\n  animation: orbit-popover-in 0.22s ease both;\n  pointer-events: auto;\n}\n\n.orbit-page--reduced .orbit-add-popover {\n  animation: none;\n}\n\n@keyframes orbit-popover-in {\n  from {\n    opacity: 0;\n    transform: translateX(calc(-50% + var(--popover-shift-x))) translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(calc(-50% + var(--popover-shift-x))) translateY(0);\n  }\n}\n\n.orbit-add-popover::after {\n  content: '';\n  position: absolute;\n  left: calc(50% - var(--popover-shift-x));\n  bottom: -7px;\n  width: 14px;\n  height: 14px;\n  transform: translateX(-50%) rotate(45deg);\n  background: var(--surface-2);\n  border-right: 1px solid var(--border-subtle);\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.orbit-add-popover-title {\n  margin: 0 0 10px;\n  color: var(--accent);\n  letter-spacing: 0.02em;\n}\n\n.orbit-add-popover-empty {\n  margin: 0;\n  color: var(--orbit-muted);\n  padding: 4px 2px 2px;\n}\n\n.orbit-add-popover-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.orbit-add-widget {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--border-subtle);\n  border-radius: 16px;\n  background: var(--surface-3);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.orbit-add-widget:hover {\n  border-color: var(--accent-ring);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n\n.orbit-add-widget-art {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  height: 72px;\n  border-radius: 12px;\n  /* closest-side keeps the glow inside the tile, otherwise the circle is still\n     opaque where it meets the short edges and reads as a hard band. */\n  background: radial-gradient(\n    ellipse closest-side at 50% 45%,\n    var(--mood-halo) 0%,\n    transparent 100%\n  );\n}\n\n.orbit-add-widget-art img {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.orbit-add-widget-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.orbit-add-widget-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.25;\n}\n\n.orbit-add-widget-desc {\n  font-size: 11px;\n  color: var(--orbit-muted);\n  line-height: 1.35;\n}\n\n.orbit-dial-glow {\n  position: absolute;\n  top: 28px;\n  left: 50%;\n  width: min(420px, 78%);\n  height: 88px;\n  transform: translateX(-50%);\n  border-radius: 50%;\n  background: radial-gradient(\n    ellipse at center,\n    var(--mood-halo) 0%,\n    transparent 70%\n  );\n  pointer-events: none;\n}\n\n.orbit-dial-items {\n  position: relative;\n  width: min(680px, 100%);\n  height: 138px;\n  margin: 0 auto;\n  overflow: visible;\n}\n\n.orbit-dial-slot {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  width: 84px;\n  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease;\n  will-change: transform, opacity;\n}\n\n.orbit-dial-slot--popover-open {\n  z-index: 60;\n}\n\n.orbit-page.is-dragging .orbit-dial-slot,\n.orbit-page--reduced .orbit-dial-slot {\n  transition: none;\n}\n\n.orbit-dial-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--orbit-ink);\n  font: inherit;\n}\n\n.orbit-dial-remove {\n  position: absolute;\n  top: -4px;\n  right: 4px;\n  display: grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid var(--border-subtle);\n  background: var(--surface-3);\n  color: var(--text-secondary);\n  cursor: pointer;\n  opacity: 0;\n  transform: scale(0.85);\n  transition: opacity 0.18s ease, transform 0.18s ease, color 0.18s ease,\n    border-color 0.18s ease;\n}\n\n.orbit-dial-slot:hover .orbit-dial-remove,\n.orbit-dial-remove:focus-visible {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.orbit-dial-remove:hover {\n  color: var(--color-warning-red);\n  border-color: var(--color-warning-red);\n}\n\n/* Touch devices have no hover, so keep the control on the selected routine */\n@media (hover: none) {\n  .orbit-dial-slot:has(.orbit-dial-item.is-active) .orbit-dial-remove {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.orbit-dial-orb {\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: var(--surface-2);\n  border: 1px solid var(--border-subtle);\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;\n}\n\n.orbit-dial-orb img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.orbit-dial-orb--add {\n  border-style: dashed;\n  border-color: var(--accent-ring);\n  background: transparent;\n  color: var(--accent);\n}\n\n.orbit-dial-item.is-active .orbit-dial-orb {\n  width: 78px;\n  height: 78px;\n  border-color: var(--accent-ring);\n  background: var(--surface-3);\n  box-shadow:\n    0 0 0 4px var(--accent-softer),\n    var(--shadow-md);\n}\n\n.orbit-dial-item.is-active .orbit-dial-orb img {\n  width: 46px;\n  height: 46px;\n}\n\n.orbit-dial-item.is-active .orbit-dial-orb--add {\n  border-style: solid;\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.orbit-dial-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--text-tertiary);\n  white-space: nowrap;\n}\n\n.orbit-dial-item.is-active .orbit-dial-label {\n  color: var(--accent);\n}\n\n@media (max-width: 860px) {\n  .orbit-stage-panel {\n    gap: var(--space-3);\n  }\n\n  .orbit-stage-object {\n    max-height: min(220px, 34vh);\n  }\n\n  .orbit-dial-items {\n    height: 128px;\n  }\n}\n\n@media (max-width: 768px) {\n  :root {\n    --orbit-dial-reserve: calc(148px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .orbit-stage {\n    padding: var(--space-3) 0 var(--space-2);\n  }\n\n  .orbit-stage-object {\n    max-height: min(180px, 30vh);\n  }\n\n  .orbit-stage-image {\n    max-width: min(148px, 46%);\n    max-height: min(148px, 26vh);\n  }\n\n  .orbit-stage-image--bed {\n    max-width: min(168px, 52%);\n  }\n\n  .orbit-stage-image--cabinet {\n    max-width: min(156px, 48%);\n  }\n\n  .orbit-stage-add {\n    width: min(112px, 40%);\n    max-height: min(112px, 22vh);\n  }\n\n  .orbit-dial {\n    padding-bottom: calc(var(--space-3) + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n@media (max-width: 640px) {\n  .orbit-stage-title {\n    font-size: clamp(26px, 7.5vw, 34px);\n  }\n\n  .orbit-stage-body {\n    font-size: 14px;\n  }\n\n  .orbit-add-popover {\n    width: min(340px, calc(100vw - 32px));\n    padding: 12px;\n  }\n\n  .orbit-add-popover-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .orbit-add-widget {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .orbit-add-widget-art {\n    width: 56px;\n    height: 56px;\n    flex-shrink: 0;\n  }\n\n  .orbit-add-widget-art img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .orbit-dial-slot {\n    width: 72px;\n  }\n\n  .orbit-dial-orb {\n    width: 58px;\n    height: 58px;\n  }\n\n  .orbit-dial-item.is-active .orbit-dial-orb {\n    width: 68px;\n    height: 68px;\n  }\n\n  .orbit-dial-orb img {\n    width: 34px;\n    height: 34px;\n  }\n\n  .orbit-dial-item.is-active .orbit-dial-orb img {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .orbit-stage-panel,\n  .orbit-dial-item,\n  .orbit-stage-image,\n  .orbit-stage-add {\n    transition: none !important;\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
